
















































































import Vue from 'vue'
import moment from 'moment/moment'
import config from '@/utils/config'
import request from '@/utils/request'
import roleMessenger from './role_messenger.vue'
import applyReservoir from './role_reservoir.vue'
import storage from '@/utils/storage'
export default Vue.extend({
    props: ['dataObj'],
    data() {
        return {
            stationShow: false,
            columnsArr: []as any,
            columns: []as any,
            station: '',
            businessId: '',
            currentToken: storage.get('token'),
            imgBaseUrl: config.imgUrl,
            showImg: false,
            showImgObj: {},
            imageList: [] as any,
            num: '',
            time: '',
            timeShow: false,
            minDate: new Date(2019, 0, 1, 0),
            maxDate: new Date(),
            currentDate: new Date(),
        }
    },
    computed: {
        managerInfo(): any {
            return this.$store.state.managerInfo
        },
        areaList(): any[] {
            return this.$store.state.areaList
        },
    },
    created() {
        this.time = moment(this.currentDate).format('YYYY-MM-DD HH时')
        // console.log(this.managerInfo)
        // console.log(this.areaList)
        // console.log(this.dataObj)
        request.get('/api/farming/rest_personnel/list').then((data) => {
            // console.log(data)
            this.columnsArr = data
            data.map((e: any) => {
                this.columns.push(e.reservoirname)
            })
            this.station = this.columns[0]
            this.businessId = this.columnsArr[0].id
        })
    },
    methods: {
        confirmSta(value: any, index: any) {
            this.station = value
            this.businessId = this.columnsArr[index].id
            this.stationShow = false
        },
        cancelSta() {
            this.stationShow = false
        },
        // 图片 - 上传
        handleSuccess(response: any, file: any, fileList: any) {
            this.$Message.success('上传完成')
            this.imageList.push({
                url: response,
                tag: response.split('.')[1],
            })
        },
        handleError(res: any) {
            console.log(res)
            this.$Message.error('上传失败，请重试')
            alert(res)
        },
        handleFormatError(file: any) {
            this.$Notice.warning({
                title: '文件格式有误',
                desc: '文件' + file.name + '格式有误, 请选择jpg、jpeg、png或mp4、MP4、avi格式文件',
            });
        },
        deletImg(index: any) {
            const arr = JSON.parse(JSON.stringify(this.imageList))
            arr.splice(index, 1)
            this.imageList = arr
        },
        checkImg(item: any) {
            this.showImg = true
            this.showImgObj = item
        },
        closeImg() {
            this.showImg = false
        },
        confirm() {
            this.timeShow = false
            this.time = moment(this.currentDate).format('YYYY-MM-DD HH时')
        },
        cancel() {
            this.timeShow = false
        },
        submit() {
            // if (this.imageList.length < 0) return this.$Message.warning('上传文件不能为空')
            if (!this.num) {return this.$Message.warning('水库水位不能为空')}
            if (!this.time) {return this.$Message.warning('观测时间不能为空')}
            const { businessId, imageList, num, time} = this
            const params = {
                businessId,
                imgPaths: imageList.map((e: any) => e.url),
                feedbackValue: num,
                observeTime: moment(this.currentDate).format('YYYY-MM-DD HH:00:00'),
                intro: '',
            }
            // console.log(params)
            const url = '/api/farming/rest_disaster_info/rsvinfo'
            request.post(url, params).then((data) => {
                // console.log(data)
                this.$Message.success('提交成功')
                this.imageList = []
                this.num = ''
            }).catch((err) => {
                console.log(err)
                this.$Message.warning(err)
            })
        },
    },
})
